import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async createSurveyForm({ commit }, data) {
      try {
        return await api.post(
          `/params/surveys/${data.surveyId}/forms`,
          data.surveyForm,
        )
      } catch (error) {
        throw error
      }
    },

    async getSurveyForms({ commit }, data) {
      try {
        const response = await api.get(`/params/surveys/${data.surveyId}/forms`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getSurveyForm({ commit }, data) {
      try {
        const response = await api.get(
          `/params/surveys/${data.surveyId}/forms/${data.surveyFormId}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateSurveyForm({ commit }, data) {
      try {
        return await api.put(
          `/params/surveys/${data.surveyId}/forms/${data.surveyFormId}`,
          data.surveyForm,
        )
      } catch (error) {
        throw error
      }
    },

    async deleteSurveyForm({ commit }, data) {
      try {
        return await api.delete(
          `/params/surveys/${data.surveyId}/forms/${data.surveyFormId}`,
        )
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
